import http from 'services/http'
import { buildUrl, downloadFile } from 'app/utils'

const funcionarioUrl = buildUrl('/rh/funcionario')

export const findAll = (filters = {}) => http.get(funcionarioUrl(), filters)

export const find = id => http.get(funcionarioUrl() + '/' + id)

export const createFuncionario = data => http.post(funcionarioUrl(), data)

export const updateFuncionario = (id, data) => http.put(funcionarioUrl() + '/' + id, data)

export const removeFuncionario = idFuncionario => http.delete(funcionarioUrl() + '/' + idFuncionario)

export const desbloquearFuncionario = (idFuncionario, data) =>
  http.patch(funcionarioUrl() + `/${idFuncionario}/desbloqueio-acesso-app`, data)

export const createMatricula = (idFuncionario, data) =>
  http.post(funcionarioUrl() + '/' + idFuncionario + '/matricula/', data)

export const updateMatricula = (idFuncionario, data) =>
  http.put(funcionarioUrl() + '/' + idFuncionario + '/matricula/', data)

export const removeMatricula = idFuncionarioRegistro =>
  http.delete(funcionarioUrl() + '/matricula/' + idFuncionarioRegistro)

export const getChaveAcessoValida = data => http.post(funcionarioUrl() + '/chave-acesso/', data)
export const createChaveAcesso = (idMatricula, data) =>
  http.post(`${funcionarioUrl()}/matricula/${idMatricula}/acesso`, data)

export const desbloqueiaMatricula = idFuncionarioRegistro =>
  http.post(funcionarioUrl() + '/matricula/' + idFuncionarioRegistro + '/desbloqueia')

export const getHistoricoChavesDesbloqueadas = idFuncionarioRegistro =>
  http.get(funcionarioUrl() + '/matricula/' + idFuncionarioRegistro + '/historico-desbloqueio')

export const enviaChaveDeAcessoEmailSms = data => http.post(funcionarioUrl() + '/chave-acesso/enviar', data)

export const downloadAnexo = dadoBancario => {
  if (!dadoBancario.id) {
    downloadFile(`comprovante-dados-bancarios-${dadoBancario.nomeArquivo}`, dadoBancario.arquivo)
    return { ok: true }
  }

  return Promise.resolve({
    ok: true,
    data: dadoBancario
  })
}

export const removeDadosBancarios = idInformacaoBancaria =>
  Promise.resolve({
    ok: true,
    data: { idInformacaoBancaria }
  })

export const getHistoricoMatriculaColaboradorList = async (params, idMatricula) =>
  await http.get(funcionarioUrl(`matricula/${idMatricula}/historico`), params)

export const getHistoricoDesloqueioColaboradorList = async (params, funcionarioId) =>
  await http.get(funcionarioUrl(`${funcionarioId}/desbloqueio-acesso-app/historico`), params)

export const getInformacoesBloqueioColaborador = async funcionarioId =>
  await http.get(funcionarioUrl(`${funcionarioId}/desbloqueio-acesso-app/informacoes-bloqueio`))

export const notificarDesbloqueio = (funcionarioId, params) =>
  http.post(funcionarioUrl() + `/${funcionarioId}/desbloqueio-acesso-app/notificar-email`, params)

export const findDadosComplementaresById = id => http.get(funcionarioUrl(id) + '/dados-complementares')

export default {
  findAll,
  find,
  createFuncionario,
  createMatricula,
  updateMatricula,
  removeMatricula,
  removeFuncionario,
  removeDadosBancarios,
  downloadAnexo,
  updateFuncionario,
  getChaveAcessoValida,
  createChaveAcesso,
  desbloqueiaMatricula,
  getHistoricoChavesDesbloqueadas,
  enviaChaveDeAcessoEmailSms,
  desbloquearFuncionario,
  getHistoricoMatriculaColaboradorList,
  getHistoricoDesloqueioColaboradorList,
  getInformacoesBloqueioColaborador,
  notificarDesbloqueio,
  findDadosComplementaresById
}
